import { ExtensionType } from "@/api/enums/ExtensionType";
import { MerchandiseClass } from "@/api/enums/merchandise-class.enum";
import { TransportMode } from "@/api/enums/transport-mode.enum";
import { Button } from "@/components/atoms/Button";
import { cn } from "@/lib/utils";
import { FormControl, FormField, FormItem } from "@atoms/Form";
import { useFormContext } from "react-hook-form";

interface ExtensionTypeButtonsProps {
  fieldName: string;
  currentPerimeter: string;
}

const ExtensionTypeButtons = ({
  fieldName,
  currentPerimeter,
}: ExtensionTypeButtonsProps) => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-col w-full gap-2">
      <h2>Je souhaite ajouter...</h2>
      <FormField
        control={control}
        name={fieldName}
        render={({ field }) => (
          <FormItem className="w-full">
            <div className="flex flex-row w-full gap-2">
              <FormControl>
                <Button
                  className={cn("flex w-full", {
                    hidden: Object.values(TransportMode).every((tm) =>
                      currentPerimeter.includes(tm)
                    ),
                  })}
                  type="button"
                  variant={
                    field.value === ExtensionType.TRANSPORTS
                      ? "default"
                      : "white"
                  }
                  onClick={() => field.onChange(ExtensionType.TRANSPORTS)}
                >
                  {"Un ou des modes de transports"}
                </Button>
              </FormControl>
              <FormControl>
                <Button
                  type="button"
                  className={cn("flex w-full", {
                    hidden: Object.values(MerchandiseClass).every((mc) =>
                      currentPerimeter.includes(mc)
                    ),
                  })}
                  variant={
                    field.value === ExtensionType.MERCHANDISES
                      ? "default"
                      : "white"
                  }
                  onClick={() => field.onChange(ExtensionType.MERCHANDISES)}
                >
                  {"Une ou des classes dangereuses"}
                </Button>
              </FormControl>
            </div>
          </FormItem>
        )}
      />
    </div>
  );
};

export default ExtensionTypeButtons;
